export default "__VITE_ASSET__DGxAcrK2__"